module.exports = __webpack_public_path__ + "d5a58fda0be6edbf9baba4e5898842fc.svg";